import {useCallback} from 'react'

import type {IColumnWithItems} from '../../api/columns/contracts/column-with-items'
import type {MemexColumnData} from '../../api/columns/contracts/storage'
import {useSetColumnValue} from '../column-values/use-set-column-value'
import {useFindMemexItem} from './use-find-memex-item'

type UpdateColumnValuesHookReturnType = {
  /**
   * Updates the list of items' column values for a single column. This method will only
   * call updateColumnValue on item models with data returned from the server.
   * @param columnWithItems A column with a list of column values for items which
   * should be updated.
   */
  updateColumnValues: (columnWithItems: IColumnWithItems) => void
}

export const useUpdateColumnValues = (): UpdateColumnValuesHookReturnType => {
  const {findMemexItem} = useFindMemexItem()
  const {setColumnValue} = useSetColumnValue()

  const updateColumnValues = useCallback(
    (columnWithItems: IColumnWithItems) => {
      if (columnWithItems.memexProjectColumnValues) {
        for (const item of columnWithItems.memexProjectColumnValues) {
          const itemModel = findMemexItem(item.memexProjectItemId)

          if (itemModel) {
            setColumnValue(itemModel, {
              memexProjectColumnId: columnWithItems.id,
              value: item.value,
            } as MemexColumnData)
          }
        }
      }
    },
    [findMemexItem, setColumnValue],
  )

  return {updateColumnValues}
}
